import React from "react";
import StudentTopMenu from "./studenttopmenu";
import StudentInfoBox from "./studentinfobox";
import { useParams } from 'react-router-dom';
import InstructorStudentNotes from "./sublist/notes";

export default function InstructorStudentNotesList() {

  let { slug } = useParams();


  return (
    <>
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          <StudentInfoBox slug={slug} />
          <StudentTopMenu slug={slug} activeMenu={"Notes"} />
          <InstructorStudentNotes slug={slug}/>
        </div>
      </div>
    </>
  );
}
